import './ytLoading.scss'

export default {
    name: 'YtLoading',

    props: {
        value: {
            type: Boolean,
            default: false
        },

        height: {
            type: Number,
            default: 120
        },

        // 加载图标位置, 'top' | 'middle', `top` 则显示在顶部 20% 位置
        // 页面较长建议使用 `top`
        position: {
            type: String,
            default: 'middle'
        },

        // 加载文字
        tips: {
            type: String,
            default: '正在加载中···'
        },

        // 是否显示加载文字
        noTips: {
            type: Boolean,
            default: true
        }
    },

    render() {
        return (
            <div
                class={`ytLoading ${this.position} ${this.noTips ? '' : 'tips'}`}
                style={`height: ${this.height}px;`}
                v-loading={this.value}
                element-loading-text={this.noTips ? '' : this.tips}
                element-loading-spinner='xoxoYeah!'
            />
        )
    }
}
